"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./item-case.scss");
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
const userHistorySlice_1 = require("../../../../redux/slices/userHistorySlice");
const moment_1 = __importDefault(require("moment"));
class ItemCase extends react_1.Component {
    render() {
        var _a, _b, _c, _d;
        const { data } = this.props;
        let caseLink;
        if (data.type === "case") {
            caseLink = `case?id=${data.hash_string}`;
        }
        else if (data.type === "cons") {
            caseLink = `cons-case?id=${data.hash_string}`;
        }
        else if (data.type === "fatt") {
            caseLink = `fatt-case?id=${data.case_id}`;
        }
        else if (data.type === "rc") {
            caseLink = `refer-case?id=${data.case_id}`;
        }
        else {
            caseLink = '#';
        }
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(core_1.Box, { className: "item-case" },
                react_1.default.createElement("div", { className: "item-case-header" },
                    react_1.default.createElement("div", { className: "case-title" }, data.title),
                    react_1.default.createElement("div", { className: "case-status" },
                        react_1.default.createElement(core_1.Hidden, { smDown: true },
                            react_1.default.createElement("p", { className: `status ${data.type === 'cons' && data.status === 'Waiting Approval' ? `cons-${(_a = data.status) === null || _a === void 0 ? void 0 : _a.toLowerCase()}` : (_b = data.status) === null || _b === void 0 ? void 0 : _b.toLowerCase()}` }, data.status)),
                        react_1.default.createElement(core_1.Hidden, { mdUp: true },
                            react_1.default.createElement("p", { className: `status ${data.type === 'cons' && data.status === 'Waiting Approval' ? `cons-${(_c = data.status) === null || _c === void 0 ? void 0 : _c.toLowerCase()}-mobile` : (_d = data.status) === null || _d === void 0 ? void 0 : _d.toLowerCase()}-mobile` })))),
                react_1.default.createElement("div", { className: "item-case-body" },
                    react_1.default.createElement("div", { className: "case-info" },
                        react_1.default.createElement("div", { className: "data-type common-text" },
                            react_1.default.createElement("p", null, data.type === 'invite' ? 'Invitees:' : 'Request Type:'),
                            data.case_type && react_1.default.createElement("p", null, "Case Type:"),
                            data.appearance_type && react_1.default.createElement("p", null, "Appearance Type:")),
                        react_1.default.createElement("div", { className: "data-value common-text" },
                            react_1.default.createElement("p", null, data.request_type),
                            react_1.default.createElement("p", null, data.case_type),
                            data.appearance_type && react_1.default.createElement("p", null, data.appearance_type))),
                    data.case_date &&
                        react_1.default.createElement("div", { className: "case-date" }, moment_1.default(data.case_date.replace("+00", ''))
                            .format('MMM DD, YYYY').toUpperCase())),
                react_1.default.createElement("div", { className: "item-case-footer" },
                    react_1.default.createElement("div", { className: "left-section" }, data.type !== 'rc' ? react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement("div", { className: 'common-text' }, data.transaction_status !== null ? `${data.price_info}:` : data.price_info || ""),
                        data.transaction_status !== null &&
                            react_1.default.createElement("div", { className: 'common-text payment-value' },
                                "$",
                                data.price),
                        data.transaction_status === 4 && data.price &&
                            react_1.default.createElement("div", { className: 'message-data' }, "IRS Pending"),
                        data.lf_is_charged && react_1.default.createElement("div", { className: 'text-addon' }, "(from Law Firm)")) : null),
                    data.type !== 'invite' && react_1.default.createElement("div", { className: "right-section" },
                        react_1.default.createElement("button", { className: 'v2-btn v2-btn-primary', onClick: () => {
                                this.props.toggleDetailsModal();
                                this.props.getCaseDetails({ id: data.case_id, type: data.type });
                            } }, "View Details"),
                        react_1.default.createElement("a", { href: `#/${caseLink}`, className: 'v2-btn v2-btn-secondary' }, "Visit Page"))))));
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        toggleDetailsModal: () => dispatch(userHistorySlice_1.toggleDetailsModal()),
        getCaseDetails: ({ id, type }) => {
            dispatch(userHistorySlice_1.getCaseDetails({ id, type }));
        }
    };
};
exports.default = react_redux_1.connect(null, mapDispatchToProps)(ItemCase);
